import { render, staticRenderFns } from "./RoomBooked.vue?vue&type=template&id=48434f66&"
import script from "./RoomBooked.vue?vue&type=script&lang=js&"
export * from "./RoomBooked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports